import { LOG_LEVEL } from '../Logger/LogLevel';
import { LOGGER_TYPE } from '../Logger/LoggerType';

export interface ILoggerConfiguration {
  'Logger Type': string;
  'Log Level': number;
  'Premise Logger URL': string;
  'Max Failed Log Buffer Size'?: number;
  'Max Log Retention'?: number;
  'Max Log Buffer Size'?: number;
  'Console Logger': IConsoleLoggerConfiguration;
}

export interface IConsoleLoggerConfiguration {
  'Max Length': number;
}

export const defaultConsoleLoggerConfiguration: IConsoleLoggerConfiguration = {
  'Max Length': 400
};

export const defaultLoggerConfiguration: ILoggerConfiguration = {
  'Logger Type': LOGGER_TYPE.DAVINCI,
  'Log Level': LOG_LEVEL.None,
  'Premise Logger URL': '',
  'Max Failed Log Buffer Size': 1500,
  'Max Log Retention': 1800000,
  'Max Log Buffer Size': 1000,
  'Console Logger': defaultConsoleLoggerConfiguration
};
